import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  bold: {
    fontWeight: 500,
  },
  title: {
    display: 'block',
    marginBottom: theme.spacing(1.25),
    color: theme.palette.grey[700],
  },
  group: {
    marginBottom: theme.spacing(1.25),
    textAlign: 'left',
  },
}));

export default useStyles;
